import { getFingerprint } from "./fingerprint";

const fingerprint = await getFingerprint();
async function getKey(password: string | undefined) {
  const enc = new TextEncoder();
  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    enc.encode(password),
    "PBKDF2",
    false,
    ["deriveKey"],
  );
  return window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: enc.encode("jLGldRoh4q4"),
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"],
  );
}

export const secureStorage = {
  key: import.meta.env.VITE_APP_SECURE_STORAGE_KEY || "default_secure_key",

  async encrypt(data: string) {
    const key = await getKey(fingerprint + this.key + fingerprint);
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const encoded = new TextEncoder().encode(data);

    const ciphertext = await window.crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      encoded,
    );

    const combined = new Uint8Array(iv.length + ciphertext.byteLength);
    combined.set(iv);
    combined.set(new Uint8Array(ciphertext), iv.length);

    return btoa(String.fromCharCode(...combined));
  },

  async decrypt(base64: string) {
    try {
      const key = await getKey(fingerprint + this.key + fingerprint);
      const combined = new Uint8Array(
        atob(base64)
          .split("")
          .map((c) => c.charCodeAt(0)),
      );

      const iv = combined.slice(0, 12);
      const ciphertext = combined.slice(12);

      const decrypted = await window.crypto.subtle.decrypt(
        { name: "AES-GCM", iv },
        key,
        ciphertext,
      );

      return new TextDecoder().decode(decrypted);
    } catch (e) {
      console.error("解密失败，数据可能被篡改", e);
      return null;
    }
  },
};
